import styled, { DefaultTheme } from "styled-components";
import { DEVICE_DIMENSIONS } from "@dineout-payment-success-ui/constants";

const HEADER_HEIGHT = "64px";
const HELP_ICON_BORDER_COLOR = "#D9DADB";
const MAX_WIDTH = "500px";
const TABLET_MAX_WIDTH = "700px";
const DEFAULT_BG_HEIGHT = 450;
const BILL_DETAILS_BOTTOM_MARGIN = "210px";
const HEADER_BG_TRANSITION = "background-color 0.3s ease-in-out";

export interface IHeaderContainerProps {
    isAndroid: boolean;
}

interface IHeaderWrapperProps {
    isScrolled?: boolean;
}

interface IBgContainerProps {
    customHeight?: number;
}

interface IPaidImageWrapperProps {
    isSavingsAvailable: boolean;
    isCalloutExists: boolean;
    isSavingCardsAvailable: boolean;
    isSplitBillWidgetAvailable?: boolean;
}

export const BgContainer = styled.div<IBgContainerProps>(({ customHeight }) => ({
    height: customHeight || DEFAULT_BG_HEIGHT,
    width: "100%",
    maxWidth: MAX_WIDTH,
    margin: "0 auto",
}));

export const getMarginTopValue = ({
    isCalloutExists,
    isSavingsAvailable,
    isSplitBillWidgetAvailable,
    theme,
}: IPaidImageWrapperProps & { theme: DefaultTheme }) => {
    if (!isCalloutExists) {
        if (isSplitBillWidgetAvailable) {
            return theme.spacing.x7;
        }
        return isSavingsAvailable ? theme.spacing.large : theme.spacing.x15;
    }
    return theme.spacing.empty;
};

export const BillDetailsWrapper = styled.div<IPaidImageWrapperProps>(
    ({ theme, isCalloutExists, isSavingsAvailable, isSavingCardsAvailable, isSplitBillWidgetAvailable }) => ({
        marginTop: getMarginTopValue({
            isCalloutExists,
            isSavingsAvailable,
            isSavingCardsAvailable,
            isSplitBillWidgetAvailable,
            theme,
        }),
        marginBottom: BILL_DETAILS_BOTTOM_MARGIN,
        position: "relative",
    }),
);

export const HeaderContainer = styled.div<IHeaderContainerProps>(({ isAndroid, theme }) => ({
    marginTop: isAndroid ? theme.spacing.xxLarge : undefined,
    position: "relative",
}));

export const HelpIconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    border: `1px solid ${HELP_ICON_BORDER_COLOR}`,
    padding: `${theme.spacing.xxSmall} ${theme.spacing.xSmall}`,
    marginLeft: theme.spacing.xSmall,
    borderRadius: theme.cornerRadius.xxSmall,
    gap: theme.spacing.xxSmall,
    alignItems: "center",
}));

export const BillHelpIconWrapper = styled.button(({ theme }) => ({
    display: "flex",
    border: `1px solid ${HELP_ICON_BORDER_COLOR}`,
    padding: `${theme.spacing.xxSmall} ${theme.spacing.xSmall}`,
    marginLeft: theme.spacing.xSmall,
    borderRadius: theme.cornerRadius.xxSmall,
    gap: theme.spacing.xxSmall,
    alignItems: "center",
    background: theme.colors[theme.colorMode].background_Secondary,
    cursor: "pointer",
}));

export const HeaderWrapper = styled.div<IHeaderWrapperProps>(({ theme, isScrolled }) => ({
    display: "flex",
    justifyContent: "space-between",
    position: "fixed",
    top: 0,
    left: 0,
    padding: theme.spacing.large,
    width: "100%",
    height: HEADER_HEIGHT,
    background: isScrolled ? theme.colors[theme.colorMode].background_Primary : "transparent",
    boxShadow: isScrolled ? theme.elevation[theme.colorMode].skim.boxShadow : "none",
    transition: HEADER_BG_TRANSITION,
    zIndex: theme.elevation[theme.colorMode].cards_And_Navigations.zIndex,

    "@supports (padding-top: var(--sat, 0px))": {
        paddingTop: `calc(var(--sat, 0px) + ${theme.spacing.large})`,
        height: `calc(var(--sat, 0px) + ${HEADER_HEIGHT})`,
        minHeight: `calc(var(--sat, 0px) + ${HEADER_HEIGHT})`,
    },

    [`@media (min-width: ${DEVICE_DIMENSIONS.DESKTOP_MIN})`]: {
        maxWidth: TABLET_MAX_WIDTH,
        left: "50%",
        transform: "translateX(-50%)",
    },
}));
